import { useEffect, useState } from "react";
import { AuthProvider, hasAuthParams, useAuth } from "react-oidc-context";
import { ORIGIN } from "./config";

const cognitoAuthConfig = {
  authority:
    "https://cognito-idp.eu-north-1.amazonaws.com/eu-north-1_ctAfkWUPX",
  client_id: "4em3h6mdo3ifehmhi7u1ts7p81",
  redirect_uri: `${ORIGIN}/login-redirect`,
  response_type: "code",
  scope: "openid",
};

const AuthHandler: React.FC<React.PropsWithChildren> = ({ children }) => {
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  useEffect(() => {
    if (
      !(
        hasAuthParams() ||
        auth.isAuthenticated ||
        auth.activeNavigator ||
        auth.isLoading ||
        hasTriedSignin
      )
    ) {
      auth.signinRedirect();
      setHasTriedSignin(true);
    }
  }, [auth, hasTriedSignin]);

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (!auth.isAuthenticated) {
    return <div>Please sign in...</div>;
  }

  return children;
};

const Auth: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <AuthProvider {...cognitoAuthConfig}>
      <AuthHandler>{children}</AuthHandler>
    </AuthProvider>
  );
};

export default Auth;
